// extracted by mini-css-extract-plugin
module.exports =  {"wells":"NlvWOaNiOPo4tGfrfPUg"};